// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MuF_R","label":"styles_label__1EGhp"};